module.exports = __webpack_public_path__ + "static/media/AMLsolutions.22e0faf5.png";